import React, { useEffect, useState } from 'react';
import ClubsResortStatCard from './ClubsResortStatCard';
import Tabs from './Tabs';
import OverviewTab from './OverviewTab';
import AudiencePerformanceTab from './AudiencePerformanceTab';
import PricingTab from './PricingTab';
import OrdersTab from './OrdersTab';
import acceptIcon from '../../assets/images/accept.svg';
import declineIcon from '../../assets/images/decline.svg';
import TermsMediaTab from './TermsMediaTab';
import { useGlobalStates } from '../../utlis/ClubsContext';
import { formatWithCommas, validatePercentage } from '../../utlis/function';
import { useNavigate, useParams } from 'react-router-dom';
import { callApi } from '../../services/ApiServices';
import EditableInfoCard from "./EditableInfoCard";
import CommonLoader from '../common/CommonLoader';
import toast from 'react-hot-toast';
import Testimonials from './Testimonials';
import { UserRole } from '../../utlis/constant';
import ImageManagemennt from './ImageManagemennt';
import SuggestionsTab from './SuggestionsTab';

const ClubsResortDetails = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [isEditingBankDetails, setIsEditingBankDetails] = useState(false);
  const { selectedClub, setSelectedClub, userRole } = useGlobalStates();
  const [isRevenueEdit, setIsRevenueEdit] = useState(false);
  const [revenueShare, setRevenueShare] = useState();
  const [error, setError] = useState("");
  const [revenueLoading, setRevenueLoading] = useState(false);
  const [loading, setLoading] = useState(false)
  const [revenueStat, setRevenueStat] = useState()
  const navigate = useNavigate()

  const { id } = useParams()
  const [bankDetails, setBankDetails] = useState({
    bankName: "Wells Fargo",
    accountHolder: "5Bridges LLC",
    accountNumber: "****9856",
  });

  const [editBankDetails, setEditBankDetails] = useState({
    bankName: "Wells Fargo",
    accountHolder: "5Bridges LLC",
    accountNumber: "****9856",
  });

  const handleBankDetailInputChange = (field, value) => {
    setEditBankDetails({
      ...editBankDetails,
      [field]: value,
    });
  };

  const handleSaveBankDetails = () => {
    setBankDetails(editBankDetails);
    setIsEditingBankDetails(false);
  };

  const handleCancelBankDetails = () => {
    setEditBankDetails(bankDetails);
    setIsEditingBankDetails(false);
  };

  const stats = [
    {
      title: "Total Screens",
      value: formatWithCommas(selectedClub?.totalScreensCount) || "0",
    },
    {
      title: "Average Monthly Visits",
      value: formatWithCommas(selectedClub?.clubMonthlyVisits || "0"),
    },
    {
      title: "Monthly Visits",
      value: formatWithCommas(selectedClub?.monthlyImpressions || "0"),
    },
    {
      title: "Average CPM",
      value: selectedClub?.avgCpm ? `${formatWithCommas(selectedClub?.avgCpm)} min` : "0",
    },
    { title: "Revenue Share", value: selectedClub?.revenuePercentage ? `${formatWithCommas(selectedClub?.revenuePercentage)} %` : "-" },
  ];

  const revenueStats = [
    { title: "Total Revenue", value: revenueStat?.total_revenue_share ? `$${formatWithCommas(revenueStat?.total_revenue_share)}` : "$0" },
    { title: "Revenue Share of Club", value: revenueStat?.revenue_for_club ? `$${formatWithCommas(revenueStat?.revenue_for_club)}` : "$0" },
    { title: "Paid to Club", value: revenueStat?.revenue_paid ? `$${formatWithCommas(revenueStat?.revenue_paid)}` : "$0" },
    { title: "Pending Payouts", value: revenueStat?.revenue_to_be_paid ? `$${formatWithCommas(revenueStat?.revenue_to_be_paid)}` : "$0" },
  ];

  const tabs = [
    { id: "overview", label: "Overview" },
    { id: "audience", label: "Audience & Performance" },
    { id: "pricing", label: "Pricing & Add-Ons" },
    { id: "revenue", label: "Revenue" },
    { id: "orders", label: "Orders" },
    { id: "terms", label: "Terms & Media" },
    { id: "images", label: "Image Management" },
    { id: "testimonial", label: "Testimonial" },
    { id: "suggestions", label: "Suggestions" },
  ];

  useEffect(() => {
    if (id) {
      fetchClubdetail(id)
    }
  }, [id])

  useEffect(() => {
    if (selectedClub) {
      setRevenueShare(selectedClub?.revenuePercentage)
      fetchRevenueStat()
    }
  }, [selectedClub])

  const fetchClubdetail = async (selectedClubId) => {
    setLoading(true)
    console.log("selectedClubId", selectedClubId)
    try {
      const response = await callApi({
        method: "get",
        url: `club/detail/${selectedClubId}`
      })
      setSelectedClub(response)
      console.log(" detail", response)
      return response
    } catch (error) {
      console.log("error while fetching club details", error)
    } finally {
      setLoading(false)
    }
  };
  const handleRevenueSave = async () => {
    if (!validatePercentage(revenueShare)) {
      setError("Revenue percentage must be between 0 and 100");
      return;
    }
    setError("");
    try {
      setLoading(true);
      const res = await callApi({
        method: "patch",
        url: `club/${selectedClub?.id}/revenue`,
        data: {
          revenuePercentage: revenueShare
        }
      })
      if (res.status === 200) {
        toast.success(res.message || "Club Revenue Updated", { id: "revenueUpdateToast" })
        fetchClubdetail(selectedClub?.id)
        setIsRevenueEdit(false);

      }
      console.log("revenue updated", res)
    } catch (error) {
      console.log("Error saving revenue share:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRevenueStat = async () => {
    try {
      // setLoading(true);
      const res = await callApi({
        method: "get",
        url: `admin/club/${selectedClub?.id}/revenue`,

      })
      console.log("revenue stat", res)
      if (res.status === 200) {
        setRevenueStat(res?.data)
      }
      console.log("revenue updated", res)
    } catch (error) {
      console.log("Error saving revenue share:", error);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <div className="">
      {/* Stats Grid */}
      {loading && <CommonLoader fullScreen />}
      <button className=' flex gap-2 items-center cursor-pointer text-primary hover:text-hover transition-colors mb-4'
        onClick={() => navigate(-1)}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 18l-6-6 6-6"
          />
        </svg>
        <span className=' font-medium text-base '>Back to club list</span>
      </button>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 md:gap-[17px] mb-6">
        {stats.map((stat, index) => (
          <ClubsResortStatCard
            key={index}
            title={stat.title}
            value={stat.value}
          />
        ))}
      </div>

      {/* Tabs Section */}
      <div className=" main-shadow rounded-[12px] overflow-hidden mb-6">
        <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
      </div>
      {/* Tab Content */}
      <div className="">
        {activeTab === "overview" && <OverviewTab />}
        {activeTab === "audience" && <AudiencePerformanceTab />}
        {activeTab === "pricing" && <PricingTab />}
        {activeTab === "revenue" && (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-3 md:gap-[17px] mb-6">
              {revenueStats.map((stat, index) => (
                <div className="bg-white rounded-xl p-4 main-shadow flex flex-col">
                  <p className="font-normal text-textcolor text-base tracking-[0] leading-[normal] mb-2">
                    {stat.title}
                  </p>
                  <h2 className="font-semibold text-black text-[35px] tracking-[0]">
                    {stat.value}
                  </h2>
                </div>
              ))}
            </div>
            {/* Revenue Configuration */}
            <div className="bg-white rounded-xl p-6 main-shadow mb-6">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h2 className="text-xl font-medium text-black tracking-[0] leading-[normal] mb-2">
                    Revenue Configuration
                  </h2>
                  <p className="text-base font-normal text-textcolor tracking-[0] leading-[20px]">
                    Allow advertisements to target specific geographic areas
                    within the venue for more precise audience targeting.
                  </p>
                </div>
                <button
                  className={`flex items-center gap-1 text-base font-medium ${userRole === UserRole.Viewer ? "cursor-not-allowed opacity-50" : "cursor-pointer"} text-black hover:text-primary transition-colors`}
                  onClick={() => setIsRevenueEdit(true)}
                  disabled={userRole === UserRole.Viewer}
                >
                  <svg
                    width={14}
                    height={14}
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Edit
                </button>
              </div>
              <div className="bg-[#F4F3F3] rounded-lg p-4 mt-6 max-w-[500px]">
                <p className="text-sm font-normal text-textcolor tracking-[0] leading-[normal] mb-2">
                  Revenue Share
                </p>
                <div className="flex justify-between">
                  {!isRevenueEdit ? (
                    <h3 className="text-[32px] font-semibold text-black tracking-[0] leading-[normal]">
                      {selectedClub?.revenuePercentage
                        ? `${selectedClub?.revenuePercentage}%`
                        : 0}
                      <span className="text-textcolor text-[15px]">
                        {" "}
                        to club
                      </span>
                    </h3>
                  ) : (
                    isRevenueEdit && (
                      <>
                        <div className="w-full">
                          <div className=" w-full flex items-center gap-2">
                            <input
                              type="number"
                              value={revenueShare}
                              min={0}
                              max={100}
                              className="w-70 px-2 py-1 border border-gray-300 rounded-md text-lg font-semibold focus:outline-none focus:ring-2 focus:ring-primary"
                              onChange={(e) => {
                                setRevenueShare(e.target.value);
                                setError("");
                              }}
                            />
                            <span className="text-textcolor text-sm">%</span>
                          </div>
                          {error && (
                            <p className="text-red-500 text-sm mt-1">{error}</p>
                          )}
                        </div>

                        {/* ---Allow/decline */}
                        <div className="flex w-[84px] gap-3">
                          <button
                            onClick={handleRevenueSave}
                            disabled={revenueLoading}
                          >
                            <img
                              src={acceptIcon}
                              alt="accept"
                              className="cursor-pointer w-[30px]"
                            />
                          </button>
                          <img
                            src={declineIcon}
                            alt="accept"
                            className="cursor-pointer w-[30px]"
                            onClick={() => {
                              setIsRevenueEdit(false);
                              setRevenueShare(
                                selectedClub?.revenuePercentage || 0,
                              );
                              setError("");
                            }}
                          />
                        </div>
                      </>
                    )
                  )}
                </div>
              </div>
            </div>
            {/* --Bank Details---- */}
            <div className="bg-white rounded-xl p-6 main-shadow mb-6">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h2 className="text-xl font-medium text-black tracking-[0] leading-[normal] mb-2">
                    Bank Account Details
                  </h2>
                </div>
                <button
                  onClick={() => setIsEditingBankDetails(true)}
                  className="cursor-pointer flex items-center gap-1 text-base font-medium text-black hover:text-primary transition-colors"
                >
                  <svg
                    width={14}
                    height={14}
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Edit
                </button>
              </div>
              <div className="flex flex-col md:flex-row justify-between">
                <div>
                  <h6 className="text-textcolor text-base">Bank Name</h6>
                  <p className="text-black font-semibold text-lg">
                    {bankDetails.bankName}
                  </p>
                </div>
                <div>
                  <h6 className="text-textcolor text-base">Account Holder</h6>
                  <p className="text-black font-semibold text-lg">
                    {bankDetails.accountHolder}
                  </p>
                </div>
                <div>
                  <h6 className="text-textcolor text-base">Account Number</h6>
                  <p className="text-black font-semibold text-lg">
                    {bankDetails.accountNumber}
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
        {activeTab === "orders" && <OrdersTab />}
        {activeTab === "terms" && <TermsMediaTab />}
        {activeTab === "testimonial" && <Testimonials />}
        {activeTab === "testimonial" && <Testimonials />}
        {activeTab ==="images" && <ImageManagemennt/>}
        {activeTab === "suggestions" && <SuggestionsTab />}
      </div>

      {/* Edit Bank Account Details Modal */}
      {isEditingBankDetails && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#000000bf] p-4">
          <div className="bg-white rounded-2xl w-full max-w-[600px] mx-auto max-h-[90vh] flex flex-col shadow-[0_4px_31.9px_11px_rgba(255,255,255,0.25)] animate-fade-in">
            {/* Modal Header - Fixed */}
            <div className="px-6 sm:px-8 pt-6 sm:pt-8 pb-4">
              <h3 className="text-2xl sm:text-[28px] font-semibold text-black mb-2">
                Bank Account Details
              </h3>
              <p className="text-sm sm:text-lg text-textcolor">
                Update the bank account information for receiving payments.
              </p>
            </div>

            {/* Modal Content - Scrollable */}
            <div className="flex-1 overflow-y-auto px-6 sm:px-8 py-6">
              <div className="space-y-4">
                {/* Bank Name */}
                <div>
                  <label className="block text-sm font-medium text-textcolor mb-2">
                    Bank Name
                  </label>
                  <input
                    type="text"
                    value={editBankDetails.bankName}
                    onChange={(e) =>
                      handleBankDetailInputChange("bankName", e.target.value)
                    }
                    className="w-full px-4 py-3 bg-white border border-gray-300 rounded-full focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent text-sm text-black"
                    placeholder="Enter bank name"
                  />
                </div>

                {/* Account Holder */}
                <div>
                  <label className="block text-sm font-medium text-textcolor mb-2">
                    Account Holder
                  </label>
                  <input
                    type="text"
                    value={editBankDetails.accountHolder}
                    onChange={(e) =>
                      handleBankDetailInputChange(
                        "accountHolder",
                        e.target.value,
                      )
                    }
                    className="w-full px-4 py-3 bg-white border border-gray-300 rounded-full focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent text-sm text-black"
                    placeholder="Enter account holder name"
                  />
                </div>

                {/* Account Number */}
                <div>
                  <label className="block text-sm font-medium text-textcolor mb-2">
                    Account Number
                  </label>
                  <input
                    type="text"
                    value={editBankDetails.accountNumber}
                    onChange={(e) =>
                      handleBankDetailInputChange(
                        "accountNumber",
                        e.target.value,
                      )
                    }
                    className="w-full px-4 py-3 bg-white border border-gray-300 rounded-full focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent text-sm text-black"
                    placeholder="Enter account number"
                  />
                </div>
              </div>
            </div>

            {/* Modal Footer - Fixed */}
            <div className="px-6 sm:px-8 py-6">
              <div className="flex flex-col sm:flex-row items-center gap-3">
                <button
                  onClick={handleCancelBankDetails}
                  className="cursor-pointer w-full sm:flex-1 px-6 py-3.5 text-base font-medium text-gray-700 bg-white border border-primary rounded-full hover:bg-gray-50 transition-colors focus:outline-none focus:ring-1 focus:ring-gray-500 focus:ring-offset-2"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveBankDetails}
                  className="cursor-pointer w-full sm:flex-1 px-6 py-3.5 text-base font-medium text-white bg-primary rounded-full hover:bg-[#164349] transition-colors focus:outline-none focus:ring-1 focus:ring-[#1e5a5f] focus:ring-offset-2"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClubsResortDetails;
